import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
// import { IconButton } from 'components/shared/IconButton/IconButton'
import { List } from 'components/shared/List/List'
import { EvaluatorCard } from '../../common/EvaluatorCard/EvaluatorCard'

// import { PlusIcon } from 'components/shared/Icon/Icon'

import styles from './EvaluatorCards.module.scss'

export const EvaluatorCards = ({
  className = undefined,
  evaluators = [],
  // onCopyLink,
  // onEditEvaluator,
  // onInviteEvaluator,
  // onRemoveEvaluator,
  // isRemoveDisabled,
}) => {
  return (
    <Box
      className={cx(styles.cards, { [className]: Boolean(className) })}
      direction="column"
      tagName="article"
    >
      <Box align="center" className={styles.heading} justify="space-between">
        <h3 className={styles.title}>{t`Evaluators`}</h3>
        {/* <IconButton
          ariaLabel="invite"
          icon={PlusIcon}
          size="small"
          variant="text"
          onClick={onInviteEvaluator}
        /> */}
      </Box>
      {R.gt(R.length(evaluators), 0) ? (
        <List className={styles.list} direction="column">
          {R.map(
            ({ email, id, name, /*shareable_url,*/ status }) => (
              <List.Item className={styles.item} key={id}>
                <EvaluatorCard
                  {...{
                    email,
                    // id,
                    name,
                    // shareable_url,
                    status,
                    // onCopyLink,
                    // onEditEvaluator,
                    // onRemoveEvaluator,
                    // isRemoveDisabled,
                  }}
                />
              </List.Item>
            ),
            evaluators,
          )}
        </List>
      ) : (
        <p className={styles.placeholder}>{t`No evaluators yet`}</p>
      )}
    </Box>
  )
}
